// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import type { ValidationRules } from "@lg/shared";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { ProxyTargetSymbol } from "@lg/shared/for-apps";
import { Semaphore } from "@lg/shared/for-apps";
import { memoize } from "@lg/shared/for-apps";
import { NgSharedModule } from "@lg/ng-shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";
import { MatCardModule } from "@angular/material/card";
import { MatTabsModule } from "@angular/material/tabs";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatButtonModule } from "@angular/material/button";
import { PdfComponent } from "@lg/ng-shared/components/pdf";
import { MatExpansionModule } from "@angular/material/expansion";
import { CustomerHistoryInclude as Orders__CustomerHistoryInclude } from "../Orders/CustomerHistoryInclude.js";
import { GenericTableComponent } from "@lg/ng-shared";
import { MatTableModule } from "@angular/material/table";
import { MatSelectModule } from "@angular/material/select";
import { MatChipsModule } from "@angular/material/chips";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { SearchableDropdownComponent } from "@lg/ng-shared";
import { VendorHistoryInclude as Orders__VendorHistoryInclude } from "../Orders/VendorHistoryInclude.js";
import { MatIconModule } from "@angular/material/icon";
import { RichTextEditorComponent } from "@lg/ng-shared/components/rich-text-editor";

interface Properties {
    request: This.CustomerRequest;
    addMaterialParsedItemIdx: number;
    addMaterial: This.Material.Entry;
    matchingVendors: This.Vendor[];
    showRedact: boolean;
    setVendorSelection: boolean;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Orders-CustomerRequestInclude',
    templateUrl: './CustomerRequestInclude.html',
    styleUrls: ['./CustomerRequestInclude.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgSharedModule,
        MatCardModule,
        MatTabsModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatButtonModule,
        PdfComponent,
        MatExpansionModule,
        Orders__CustomerHistoryInclude,
        GenericTableComponent,
        MatTableModule,
        MatSelectModule,
        MatChipsModule,
        MatAutocompleteModule,
        SearchableDropdownComponent,
        Orders__VendorHistoryInclude,
        MatIconModule,
        RichTextEditorComponent
    ],
})
export class CustomerRequestInclude extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Orders.CustomerRequestInclude';
    $isDialog = false;
    $Modules = $Modules;
    Orders = Orders;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    _DataTableBlock_columns_55 = (screen: Properties) => ['name', 'method', 'dimensions', 'quantities', 'attachments', 'materials'];
    $validators: Record<number, ValidationRules> = {
        137: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled } = $scope
                if (!$value || $value.match(/^20\d{8}$/)) return undefined
                return {
                    error: 'Needs to be 10 digits, starting with year',
                    ruleId: 'format',
                }
            },
            ($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value === 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        }
    };
    input_request = input(undefined, { alias: 'request' });
    var_request = proxySignal<This.CustomerRequest>(undefined as any);
    var_addMaterialParsedItemIdx = proxySignal<number>(undefined as any);
    var_addMaterial = proxySignal<This.Material.Entry>(undefined as any);
    var_matchingVendors = proxySignal<This.Vendor[]>(undefined as any);
    var_showRedact = proxySignal<boolean>(undefined as any);
    input_setVendorSelection = input(undefined, { alias: 'setVendorSelection' });
    var_setVendorSelection = proxySignal<boolean>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get request() { return component.var_request() },
                set request(value: This.CustomerRequest) { component.var_request.set(value) },
                get addMaterialParsedItemIdx() { return component.var_addMaterialParsedItemIdx() },
                set addMaterialParsedItemIdx(value: number) { component.var_addMaterialParsedItemIdx.set(value) },
                get addMaterial() { return component.var_addMaterial() },
                set addMaterial(value: This.Material.Entry) { component.var_addMaterial.set(value) },
                get matchingVendors() { return component.var_matchingVendors() },
                set matchingVendors(value: This.Vendor[]) { component.var_matchingVendors.set(value) },
                get showRedact() { return component.var_showRedact() },
                set showRedact(value: boolean) { component.var_showRedact.set(value) },
                get setVendorSelection() { return component.var_setVendorSelection() },
                set setVendorSelection(value: boolean) { component.var_setVendorSelection.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            request: this.screen.request,
            setVendorSelection: this.screen.setVendorSelection
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_request = this.dialogData?.data?.request ?? this.input_request() ?? (undefined)
            if (new_request !== undefined) this.screen.request = new_request

            if (!isVariablesInitialized) this.screen.addMaterialParsedItemIdx = (undefined)
            if (!isVariablesInitialized) this.screen.addMaterial = (undefined)
            if (!isVariablesInitialized) this.screen.matchingVendors = ([])
            if (!isVariablesInitialized) this.screen.showRedact = (false)

            const new_setVendorSelection = this.dialogData?.data?.setVendorSelection ?? this.input_setVendorSelection() ?? (false)
            if (new_setVendorSelection !== undefined) this.screen.setVendorSelection = new_setVendorSelection

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    _ScopeBlock_var_isPdf_107($scope: any): boolean {
        let { app, screen, $pathSegments, $disabled, drawing, drawingIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, drawing: This.CustomerRequestAttachment, drawingIndex: number } = $scope ?? {}

        const memoizedFn = memoize($scope, () => {
            return (
                drawing.mimeType == 'application/pdf'
            )
        })
        return memoizedFn()
    }

    async handler_ButtonBlock_139_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { drawing, drawingIndex, isPdf, $disabled }: { drawing: This.CustomerRequestAttachment, drawingIndex: number, isPdf: boolean, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    Sys.App.provideDownload(drawing.data.data, drawing.fileName, drawing.mimeType)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    _DataTableBlock_collectionCodeSignal_55(component: any, $scope: any): any {

        return this.getMemoizedSignal(component, 'collectionCode', () =>
            computed(() => {
                let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}
                return (screen.request.items)
            }, { equal: () => false })
        )

    }

    _DataTableBlock_additionalFindOptions_55($scope: any): any {
        let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}

        return ({})
    }

    async handler_ChipGroupBlock_104_input_matChipInputTokenEnd_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { item, itemIndex, quantity, quantityIndex, $disabled }: { item: This.CustomerRequestItem, itemIndex: number, quantity: number, quantityIndex: number, $disabled: any } = $scope ?? {}

        {
            let event: Sys.Types.MatChipInputEvent = $event
            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    if (event.value?.match(/^\s*\d+\s*$/)) {
                        item.quantities.push(Number(event.value))
                        item.quantities.sort((a, b) => a - b)
                        event.chipInput.inputElement.value = ''
                    }
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ChipGroupBlock_104_chip_removed_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { item, itemIndex, quantity, quantityIndex, $disabled }: { item: This.CustomerRequestItem, itemIndex: number, quantity: number, quantityIndex: number, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    item.quantities.splice(quantityIndex, 1)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ChipGroupBlock_109_dropdown_optionSelected_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { item, itemIndex, attachment, attachmentIndex, $disabled }: { item: This.CustomerRequestItem, itemIndex: number, attachment: This.CustomerRequestAttachment, attachmentIndex: number, $disabled: any } = $scope ?? {}

        {
            let event: any = $event.option.value
            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    item.relatedAttachmentIds.push(event)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ChipGroupBlock_109_chip_removed_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { item, itemIndex, attachment, attachmentIndex, $disabled }: { item: This.CustomerRequestItem, itemIndex: number, attachment: This.CustomerRequestAttachment, attachmentIndex: number, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    item.relatedAttachmentIds = item.relatedAttachmentIds.filter(aId => aId != attachment.id)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_43_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { item, itemIndex, itemMaterial, itemMaterialIndex, $disabled }: { item: This.CustomerRequestItem, itemIndex: number, itemMaterial: This.CustomerRequestItemMaterial, itemMaterialIndex: number, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    item.materials.splice(itemMaterialIndex, 1)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_43_click_recalculateVendors_1($event: any, $scope: any): Promise<void> {
        let { item, itemIndex, itemMaterial, itemMaterialIndex, $disabled }: { item: This.CustomerRequestItem, itemIndex: number, itemMaterial: This.CustomerRequestItemMaterial, itemMaterialIndex: number, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                await this.action_recalculateVendors($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_SearchableDropdownBlock_44_optionSelected_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { item, itemIndex, $disabled }: { item: This.CustomerRequestItem, itemIndex: number, $disabled: any } = $scope ?? {}

        {
            let $option: This.Material.Entry | null = $event
            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    item.materials.push(new This.CustomerRequestItemMaterial({
                        name: screen.addMaterial.name
                    }))
                    screen.addMaterial = undefined
                    screen.addMaterialParsedItemIdx = undefined
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_SearchableDropdownBlock_44_optionSelected_recalculateVendors_1($event: any, $scope: any): Promise<void> {
        let { item, itemIndex, $disabled }: { item: This.CustomerRequestItem, itemIndex: number, $disabled: any } = $scope ?? {}

        {
            let $option: This.Material.Entry | null = $event
            const { app, screen, output } = this
            try {
                await this.action_recalculateVendors($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async _SearchableDropdownBlock_collectionCode_44($scope: any): Promise<any> {
        let { app, screen, $pathSegments, $disabled, item, itemIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.CustomerRequestItem, itemIndex: number } = $scope ?? {}

        return (This.Material.getEntryList())
    }

    _SearchableDropdownBlock_displayWith_44($option: any, $index: number, $scope: Record<string, any>) {
        const { app, screen, $pathSegments, $disabled, item, itemIndex } = $scope ?? {}

        const $label = $option.name
        return $label ?? ''
    }

    async handler_ButtonBlock_56_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { item, itemIndex, $disabled }: { item: This.CustomerRequestItem, itemIndex: number, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    screen.addMaterialParsedItemIdx = itemIndex
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_75_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    const itemLines = screen.request.items.map((item, idx) => {
                        const relatedAttachmentsNames = screen.request.attachments
                            .filter(a => item.relatedAttachmentIds.includes(a.id))
                            .map(a => a.fileName)
                        return `<p>
        {{item ${idx + 1}}}<br>
        <b>${item.name}</b> (${relatedAttachmentsNames.join(', ')})<br>
        Material: ${item.materials.map(m => m.name).join(' / ')}<br>
        Quantities: ${item.quantities.join(' / ')}<br>
        {{/item}}
    </p>`
                    }).join('\n\t')

                    screen.request.vendorRequestHtmls = {
                        de: `
    <p>Guten Tag</p>
    <p>Wir bitten Sie um eine Offerte zur Fertigung und Lieferung der folgenden Artikel gemäss angehänten Zeichnungen:</p>
    
    ${itemLines}
    
    <p></p>
    <p>
        Vielen Dank und beste Grüsse<br>
        ${This.$Config.Company.name}
    </p>
    <p></p>    

    ${This.$Config.Company.emailSignature}
    `,

                        en: `
    <p>Hi</p>
    <p>Please make an offer for the production and delivery of the following items according to the attached drawing(s):</p>
    
    ${itemLines}
    
    <p></p>
    <p>
        Thank you and best regards<br>
        ${This.$Config.Company.name}
    </p>
    <p></p>
    
    ${This.$Config.Company.emailSignature}
    `
                    }
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    _ForBlock_collectionCode_81($scope: any): any[] {
        let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}

        return (This.VendorLanguage.getEntryList())
    }

    async handler_InputBlock_137_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {
            let event: MouseEvent = $event
            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    if (!screen.request.projectNumber && !$disabled) {
                        screen.request.projectNumber = Sys.Date.format(new Date, 'yyyy')
                    }
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            this.action_recalculateVendors($event)
        }
    }

    async action_recalculateVendors($event?: any) {
        const { app, screen, output } = this
        {
            await Promise.all([
                This.Vendor.load(true),
                This.VendorMaterial.load(true),
            ])

            screen.matchingVendors = This.Vendor.getEntryList().filter(v => {
                const vendorMaterials = This.VendorMaterial.getEntryList().filter(sm => sm.supplierId == v.id)
                const requestMaterials = screen.request.items.flatMap(item => item.materials.map(m => m.name))
                return vendorMaterials.some(vm => requestMaterials.includes(vm.materialName))
            }).map(entry => new This.Vendor(entry.id))

            if (screen.setVendorSelection) {
                screen.request.vendorSelection = {}
                for (const vendor of screen.matchingVendors) {
                    const vendorItemSelection = screen.request.vendorSelection[vendor.id] = {}
                    const vendorMaterials = This.VendorMaterial.getEntryList().filter(sm => sm.supplierId == vendor.id)

                    for (const item of screen.request.items) {
                        const isRelevant = item.materials.some(im => vendorMaterials.some(vm => im.name == vm.materialName))
                        vendorItemSelection[item.id] = isRelevant ? true : null // null = disable the input checkbox
                    }
                }
            }

        }
    }
}
